import { createFileRoute, redirect } from '@tanstack/react-router'
import { Auth } from '@/components/auth'
import { z } from "zod"
import { isAuthenticated, recoverTokensFromSession, getAuthRedirectTarget } from "@/auth"
import { installFlowSensorKitSerial } from "@/installFlow/storage-keys"

export const Route = createFileRoute('/login')({
  component: Auth,
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  // Auth redirects for already-authenticated users must happen here in
  // beforeLoad, never in a component useEffect (causes login form flicker).
  beforeLoad: async ({ search }) => {
    const redirectArgs = {
      isInstallFlow: !!installFlowSensorKitSerial.get(),
      searchRedirect: search.redirect,
    }

    // Fast path: JWT tokens already in localStorage
    const fastTarget = getAuthRedirectTarget({ isAuthenticated: isAuthenticated(), ...redirectArgs })
    if (fastTarget) throw redirect({ to: fastTarget })

    // Slow path: recover tokens from an existing backend session (2s cap)
    const recovered = await recoverTokensFromSession()
    if (recovered) {
      const slowTarget = getAuthRedirectTarget({ isAuthenticated: true, ...redirectArgs })
      if (slowTarget) throw redirect({ to: slowTarget })
    }
  },
})
